import { PC_BREAKPOINT } from 'shared/constants'
import css from 'styled-jsx/css'

export default css`
  .title {
    font-weight: bold;
    font-size: 30px;
    margin: 16px 28px;
    word-wrap: break-word;
    letter-spacing: -0.04em;
  }
  .description {
    margin: 0 28px 24px 28px;
    font-size: 16px;
    word-wrap: break-word;
  }
  .cats {
    margin: 0 28px 24px 28px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
  }
  .cat {
    padding: 2px 8px;
    background-color: rgba(245, 245, 245, 1);
    border-radius: 4px;
  }
  .cats-filter {
    display: flex;
    align-items: center;
    gap: 6px;
    padding-left: 28px;
    margin-bottom: 16px;
    overflow: auto;
  }
  .cat-filter {
    border: 1px solid rgba(230, 233, 236, 1);
    padding: 6px 12px;
    border-radius: 24px;
    background-color: #fff;
    flex-shrink: 0;
    cursor: pointer;
    font-size: 16px;
  }
  .cat-filter-active {
    border-color: rgba(238, 77, 45, 1);
    background-color: rgba(255, 241, 240, 1);
    color: rgba(238, 77, 45, 1);
  }

  @media screen and (min-width: ${PC_BREAKPOINT}px) {
    .title {
      margin: 48px 100px 16px 100px;
    }
    .description {
      margin: 0 100px 24px 100px;
    }
    .cats {
      margin: 0 100px 24px 100px;
    }
    .cats-filter {
      padding-left: 100px;
    }
  }
`
